// Defensive shim: guarantee a `process.env` object exists in the browser.
//
// The webpack DefinePlugin in preact.config.js replaces `process.env.APP_VERSION`
// (and similar) with string literals at build time. If that replacement ever
// fails to run (e.g. preact.config.js silently fails to load — as happened when
// the unmaintained `esm@3.2.25` loader crashed on modern Node), the bundle ships
// raw `process.env.X` references. In a browser `process` is undefined, so the
// very first such reference throws `ReferenceError: process is not defined` at
// module-init time and white-screens the ENTIRE app — every route, including the
// token-creation / payment pages.
//
// Defining a minimal `process.env` here turns that fatal crash into a harmless
// `undefined` lookup. It is intentionally the first thing the entry imports so it
// runs before any other module touches `process`.
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
    window.process = { env: {} };
} else if (typeof globalThis !== 'undefined' && typeof globalThis.process === 'undefined') {
    globalThis.process = { env: {} };
}
